import { useEffect, useRef } from "react";

/**
 * Brings the row a link from another page named into view and flashes it, for
 * register pages whose rows have no detail panel to open. Mark the row with
 * `data-deeplink={row.id}`; call with the id from the query string and whether
 * the rows have rendered. Runs once per id, so the page can be scrolled away
 * from afterwards.
 */
export function useDeepLinkScroll(id: string | null | undefined, ready: boolean) {
  const done = useRef<string | null>(null);
  useEffect(() => {
    if (!id || !ready || done.current === id) return;
    const t = window.setTimeout(() => {
      const el = document.querySelector<HTMLElement>(`[data-deeplink="${CSS.escape(id)}"]`);
      if (!el) return;
      done.current = id;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.remove("deeplink-flash");
      void el.offsetWidth;
      el.classList.add("deeplink-flash");
    }, 60);
    return () => window.clearTimeout(t);
  });
}
